require('./bootstrap');
require('jquery-ui');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/i18n/datepicker-hu');
require('@justinribeiro/lite-youtube');